import { useMemo } from 'react';
import { SupportedTranslation, useI18n } from '../context/I18nContext';
import { Maybe, ParkingTerms, SupportLanguage } from '../types/appsync-types';

const mapSupportedTranslationToSupportLanguage = (locale: SupportedTranslation): SupportLanguage => {
  switch (locale) {
    case SupportedTranslation.enSE:
    case SupportedTranslation.en:
      return SupportLanguage.EN;
    case SupportedTranslation.sv:
    case SupportedTranslation.svSE:
      return SupportLanguage.SV;
    default:
      return SupportLanguage.FI;
  }
};

export const useParkingTermsUrlForCurrentLocale = (
  parkingTerms: Maybe<Maybe<ParkingTerms>[]> | undefined,
): string | undefined => {
  const { currentLocale } = useI18n();

  const parkingTermsUrl = useMemo(() => {
    const currentLang = mapSupportedTranslationToSupportLanguage(currentLocale);

    let url = parkingTerms?.find((terms) => terms?.lang === currentLang)?.url;

    if (!url) {
      if (currentLang === SupportLanguage.EN) {
        url = parkingTerms?.find((terms) => terms?.lang === SupportLanguage.FI)?.url ?? parkingTerms?.[0]?.url;
      } else {
        url = parkingTerms?.find((terms) => terms?.lang === SupportLanguage.EN)?.url ?? parkingTerms?.[0]?.url;
      }
    }

    return url ?? undefined;
  }, [currentLocale, parkingTerms]);

  return parkingTermsUrl;
};
